import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch, Redirect } from 'react-router-dom'

import WatchlistInfoContainer from './WatchlistInfo/WatchlistInfoContainer'
import { onEnter } from '../../utils/UpdateData'

class Watchlist extends PureComponent {
  render () {
    return (
      <div className='app-route'>
        <div className='body-container'>
          <div className='inner-container'>
            {onEnter(
              <Switch>
                <Route exact path='/main/watchlist'
                  component={WatchlistInfoContainer} />
                <Redirect to='/main/watchlist' />
              </Switch>
            )}
          </div>
        </div>
      </div>
    )
  }
}

Watchlist.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

Watchlist.defaultProps = {}

export default Watchlist
